// 韩语
const userModule = {
  user: "나의",
  userName: "이름",
  userInfo: "사용자 정보",
  phone: "연락 전화",
  sex: "성별",
  updatePassword: "비밀번호 수정",
  myOrder: "내 주문서",
  myCoupon:"선혜권",
  aboutService: "우리에 관하여",
  rule1: "이용약관",
  rule2: "보호 방침",
  returnLogin: "나가기",
  sex0: "비밀",
  sex1: "남자",
  sex2: "여자",
  email: "메일 박스",
};
export default userModule;